import http from "@/utils/http";


export const doorEventApi = {
	page(query) {
		return http.get(`/nexus/acsNexusEventLog/page`,query)
	},
}